var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPort(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg",
    width: "52px",
    height: "52px",
    viewBox: "0 0 52 52",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M0 0L49 0L49 49L0 49L0 0Z",
    id: "path_1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0L25 0L25 25L0 25L0 0Z",
    id: "path_2"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "mask_1"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path_1"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "mask_2"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path_2"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Portfolio-Icon"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(0 3)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0L49 0L49 49L0 49L0 0Z",
    id: "Clip-2",
    fill: "none",
    fillRule: "evenodd",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#mask_1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.5 45.8348C24.449 45.8348 24.3984 45.8323 24.3484 45.8309L24.1185 45.8244C18.1057 45.7189 12.6801 43.0725 8.85518 38.9336L22.7407 27.659L45.6017 27.659C44.0683 37.9311 35.1898 45.8348 24.5 45.8348L24.5 45.8348ZM6.8813 36.4592C5.49504 34.4314 4.44518 32.1602 3.8224 29.726L15.1741 29.726L6.8813 36.4592ZM3.16444 24.4943C3.16444 23.4199 3.26502 22.3688 3.42108 21.3356L20.8986 21.3356L20.8986 24.4943L20.8986 25.0781L19.0718 26.5608L3.267 26.5608C3.20011 25.8804 3.16444 25.1911 3.16444 24.4943L3.16444 24.4943ZM6.61822 12.9516L20.8986 12.9516L20.8986 18.1704L4.15336 18.1704C4.73848 16.31 5.57282 14.5592 6.61822 12.9516L6.61822 12.9516ZM20.8986 3.46797L20.8986 9.78642L9.12322 9.78642C12.2228 6.5479 16.3107 4.25938 20.8986 3.46797L20.8986 3.46797ZM24.063 24.4943L24.063 0C10.7344 0.233907 0 11.1066 0 24.4943C0 37.8815 10.7344 48.7542 24.063 48.9886C24.2087 48.9916 24.3533 49 24.5 49C38.0312 49 49 38.0282 49 24.4943L24.063 24.4943Z",
    id: "Fill-1",
    fill: "#222B2F",
    fillRule: "evenodd",
    stroke: "none"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group-6",
    transform: "translate(27 0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0L25 0L25 25L0 25L0 0Z",
    id: "Clip-5",
    fill: "none",
    fillRule: "evenodd",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#mask_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.17231 3.40597C12.6381 4.64004 20.1886 12.1972 21.5933 21.771L3.17231 21.771L3.17231 3.40597ZM0.439067 0C0.291552 0 0.147018 0.00859454 0 0.0116279L0 25L25 25C25 11.1926 14.004 0 0.439067 0L0.439067 0Z",
    id: "Fill-4",
    fill: "#D08E01",
    fillRule: "evenodd",
    stroke: "none"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPort);
export default __webpack_public_path__ + "static/media/port.5b9fc09c4bdf5ba327e3d1b69798603a.svg";
export { ForwardRef as ReactComponent };